import { render, staticRenderFns } from "./customDashboardCard.vue?vue&type=template&id=365ed9a8&scoped=true"
import script from "./customDashboardCard.vue?vue&type=script&lang=js"
export * from "./customDashboardCard.vue?vue&type=script&lang=js"
import style0 from "./customDashboardCard.vue?vue&type=style&index=0&id=365ed9a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365ed9a8",
  null
  
)

export default component.exports